import React from 'react';
import { Icon } from './Icon.js';
export const IconSparkle4Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m11.526,5.303l-3.46-1.369L6.697.474c-.113-.286-.39-.474-.697-.474s-.584.188-.697.474l-1.369,3.46L.474,5.303c-.286.113-.474.39-.474.697s.188.584.474.697l3.46,1.369,1.369,3.46c.113.286.39.474.697.474s.584-.188.697-.474l1.368-3.46,3.46-1.369c.286-.113.474-.39.474-.697s-.188-.584-.474-.697Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconSparkle4Fill12.js.map